module.exports = __webpack_public_path__ + "static/img/empty.40d9073f.png";